import * as React from 'react';
import { History } from 'history';
import Model from './user-model';
import BaseChecklist from '../base/base-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
  history: History;
  caption?: string;
  onLoad?: (data: any) => void;
  currentId: any;
  readOnly?: boolean;
  disableBackButton? : boolean;
}

interface IState {
}

export default class UserChecklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }



  public render(): React.ReactNode {
    return (
      <BaseChecklist history={this.props.history} caption={this.props.caption} endPointFilter={AppService.isAppFullVersion()?'':Model.endPointFilterList()} model={Model} currentId={this.props.currentId} onLoad={this.props.onLoad} searchField='name' readOnly={this.props.readOnly} disableBackButton={this.props.disableBackButton}/>
    );
  }
}
